import Component from 'classes/Component'
import GSAP from 'gsap'
import { each, indexOf } from 'lodash'
import flatpickr from "flatpickr";
import rangePlugin from "flatpickr/dist/plugins/rangePlugin"
import { Portuguese } from "flatpickr/dist/l10n/pt.js"

export default class Availability extends Component {
    constructor () {
        super({
            element: '.availability',
            elements: {
                wrapper: '.availability_wrapper',
                dates: '.availability_dates',
                guests: '.availability_guests',
                button: '.availability_button',
                menuButton: '.menu_button',
                calendarToggle: '.availability_dates_buttons',
                calendarToggle2: '.availability_dates_buttons2',
                bookingCalendar : '.bookingCalendar',
                closeBookingCalendar : '.closeBookingCalendar',
                bookingCalendarWrapper: '.bookingCalendar_wrapper',
                guestsSelector: '.availability_guests',
                search: '.search',
                numberAdultMinus: '.availalibity_adults_selector_minus',
                numberAdultPlus: '.availalibity_adults_selector_plus',
                number_0_2_minus: '.availalibity_0_2_selector_minus',
                number_0_2_plus: '.availalibity_0_2_selector_plus',
                number_2_16_minus: '.availalibity_2_16_selector_minus',
                number_2_16_plus: '.availalibity_2_16_selector_plus',
                submitSearchBooking : '#submitSearchBooking',
                formSearchBooking : '#formSearchBooking',
                clearCalendar : '#clearCalendar',
                //buttonNoDates: '#searchDatesAgain',
                calendarToggle3 : '.reserve_button',
                header: document.querySelector('.header')
            },
        })

        this.elements.all = [
            this.elements.dates,
            this.elements.guests
        ]


        this.calendarConfig = this.calendarConfig();
        this.calendar = this.loadCalendar();
        this.detectCalendarChange();
        this.createInteractions();

        this.loadBookingCookies();
        this.tl = GSAP.timeline()
    }

    /** Booking Cookies **/
    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        //console.log("cookie added",cname,cvalue,exdays);
    }


    //verify Booking Cookies
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    loadBookingCookies(){
        /*** Booking Cookies Checker ***/
        const BookingCheckInDate = this.getCookie('BookingCheckInDate');
        const BookingCheckOutDate = this.getCookie('BookingCheckOutDate');
        const BookingAdults = this.getCookie('BookingAdults');
        const BookingChildren02 = this.getCookie('BookingChildren02');
        const BookingChildren216 = this.getCookie('BookingChildren216');

        if(BookingCheckInDate && BookingCheckOutDate){
            var inputCheckInDate = BookingCheckInDate.split("/").reverse().join("-");
            document.getElementById("checkInDateUser").innerHTML = BookingCheckInDate;
            document.getElementById("mphb_check_in_date").value = inputCheckInDate;

            var inputCheckOutDate = BookingCheckOutDate.split("/").reverse().join("-");
            document.getElementById("checkOutDateUser").innerHTML = BookingCheckOutDate;
            document.getElementById("mphb_check_out_date").value = inputCheckOutDate;

            //this.calendar.setDate(['2022-07-19','2022-07-22']);
        }

        if(BookingAdults){
            document.getElementById('mphb_adults').setAttribute('value', BookingAdults);
            document.getElementsByClassName('availalibity_adults_selector_number')[0].innerHTML = BookingAdults;
        }

        if(BookingChildren02){
            document.getElementById('mphb_children_0_2').setAttribute('value', BookingChildren02);
            document.getElementsByClassName('availalibity_0_2_selector_number')[0].innerHTML = BookingChildren02;
        }

        if(BookingChildren216){
            document.getElementById('mphb_children_2_16').setAttribute('value', BookingChildren216);
            document.getElementById('mphb_children').setAttribute('value', BookingChildren216);
            document.getElementsByClassName('availalibity_2_16_selector_number')[0].innerHTML = BookingChildren216;
        }
    }

    /*** Clear Calendar ***/
    clearCalendar = () => {
        this.calendar.clear();
    }

    /** Calendar **/
    detectCalendarChange(){
        this.calendar.config.onChange.push(function(dateobj, datestr) {

            // console.log(dateobj[0],dateobj[1]);

            document.getElementById('inputDatesWarning').classList.remove('visible');
            document.getElementById('checkBookingDates').classList.remove('visible');

            if (dateobj[0] && dateobj[1]) {
                var range = dateobj[1] - dateobj[0];
                //console.log(dateobj[0],dateobj[1])
                range = range / 86400000;
                //console.log(range);

                if(range == 0){

                }
                else if(range > 0 && range < 2){
                    document.getElementById("checkInDateUser").innerHTML = 'Check-in';
                    document.getElementById("checkOutDateUser").innerHTML = 'Check-out';
                    document.getElementById("mphb_check_in_date").value = '';
                    document.getElementById("mphb_check_out_date").value = '';
                    //console.log("Minimum Stay: 2 Days");
                    document.getElementById('checkBookingDates').classList.add('visible');
                }
                else{
                    let exdays = 1;
                    var d = new Date();
                    d.setTime(d.getTime() + (exdays*24*60*60*1000));
                    var expires = "expires="+ d.toUTCString();

                    if(dateobj[0]){
                        var checkInDateForUser = dateobj[0].toLocaleDateString("en-GB", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                        })

                        var checkInDate = new Date(dateobj[0].getTime() - (dateobj[0].getTimezoneOffset() * 60000 )).toISOString().split("T")[0];

                        document.getElementById("checkInDateUser").innerHTML = checkInDateForUser;
                        document.getElementById("mphb_check_in_date").value = checkInDate;
                        document.cookie = "BookingCheckInDate=" + checkInDateForUser + ";" + expires + ";path=/";
                    }

                    if(dateobj[1]){
                        var checkOutDateForUser = dateobj[1].toLocaleDateString("en-GB", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                        })

                        var checkOutDate = new Date(dateobj[1].getTime() - (dateobj[1].getTimezoneOffset() * 60000 )).toISOString().split("T")[0];

                        document.getElementById("checkOutDateUser").innerHTML = checkOutDateForUser;
                        document.getElementById("mphb_check_out_date").value = checkOutDate;
                        document.cookie = "BookingCheckOutDate=" + checkOutDateForUser + ";" + expires + ";path=/";
                    }
                }


            }

        });
    }


    calendarConfig(){

        var BookingCheckInDate = this.getCookie('BookingCheckInDate');
        var BookingCheckOutDate = this.getCookie('BookingCheckOutDate');
        var BookingCheckInDate = BookingCheckInDate.split("/").reverse().join("-");
        var BookingCheckOutDate = BookingCheckOutDate.split("/").reverse().join("-");


        return {
            plugins: [new rangePlugin({ input: "#checkOutDate" })],
            minDate: "today",
            enableTime: false,
            altInput: true,
            altFormat: "d/m/Y",
            dateFormat: "Y-m-d",
            defaultDate: [BookingCheckInDate,BookingCheckOutDate],
            inline: true,
            monthSelectorType: "static",
            mode: 'single',
            nextArrow: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#F6F4F4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 16L16 12L12 8" stroke="#F6F4F4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 12H16" stroke="#F6F4F4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`,
            prevArrow: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#F6F4F4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 8L8 12L12 16" stroke="#F6F4F4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16 12H8" stroke="#F6F4F4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            `,
            disable: booking_block_dates_rules,
            //yearSelectorType: input|static
            //maxDate: "15.12.2017",
            //minDate: "15.12.2017",
            //disable: ["2025-01-30", "2025-02-21", "2025-03-08", new Date(2025, 4, 9) ],
            // disable: [
            //     {
            //         from: "2025-04-01",
            //         to: "2025-05-01"
            //     },
            //     {
            //         from: "2025-09-01",
            //         to: "2025-12-01"
            //     }
            // ],
            // {
            //     enable: [
            //         {
            //             from: "2025-04-01",
            //             to: "2025-05-01"
            //         },
            //         {
            //             from: "2025-09-01",
            //             to: "2025-12-01"
            //         }
            //     ]
            // }
            onReady: function (dateObj, dateStr) {
                //console.log('----', this)
            },
            // onClose: function(selectedDates, dateStr, instance) {
            //     if(selectedDates.length == 1){
            //         instance.setDate([selectedDates[0],selectedDates[0]], true);
            //     }
            // }
        };
    }

    loadCalendar(){

        /** Change Calendar Lang **/
        if(currentSiteLang == 'pt-pt'){
            flatpickr.localize(Portuguese);
        }

        return flatpickr("#checkInDate", this.calendarConfig);

    }
    /** Adult **/
    numberAdultMinus = () => {
        var currentAdultNumber = Number(document.getElementById('mphb_adults').value) || 1;

        if(currentAdultNumber == 1){
            this.setAdultNumber(1);
        }
        else if ( currentAdultNumber > 1 ) {
            this.setAdultNumber( currentAdultNumber - 1 );
        }
    }

    numberAdultPlus = () => {
        var currentAdultNumber = Number(document.getElementById('mphb_adults').value) || 0;
        this.setAdultNumber( currentAdultNumber + 1 );
    }

    setAdultNumber( number ) {
        document.getElementById('inputNrGuestsWarning').classList.remove('visible');
        document.getElementById('mphb_adults').setAttribute('value', number);
        document.getElementsByClassName('availalibity_adults_selector_number')[0].innerHTML = number;
        this.setCookie('BookingAdults',number,1);
    }

    /** 0 - 2 years **/
    number02Minus = () => {
        var currentNumber = Number(document.getElementById('mphb_children_0_2').value) || 1;

        if ( currentNumber > 0 ) {
            this.set02Number( currentNumber - 1 );
        }
    }

    number02Plus = () => {
        var currentNumber = Number(document.getElementById('mphb_children_0_2').value) || 0;
        this.set02Number( currentNumber + 1 );
    }

    set02Number( number ) {
        document.getElementById('mphb_children_0_2').setAttribute('value', number);
        document.getElementsByClassName('availalibity_0_2_selector_number')[0].innerHTML = number;
        this.setCookie('BookingChildren02',number,1);
    }


    /** 0 - 2 years **/
    number216Minus = () => {
        var currentNumber = Number(document.getElementById('mphb_children_2_16').value) || 1;

        if ( currentNumber > 0 ) {
            this.set216Number( currentNumber - 1 );
        }
    }

    number216Plus = () => {
        var currentNumber = Number(document.getElementById('mphb_children_2_16').value) || 0;
        this.set216Number( currentNumber + 1 );
    }

    set216Number( number ) {
        document.getElementById('mphb_children_2_16').setAttribute('value', number);
        document.getElementById('mphb_children').setAttribute('value', number);
        document.getElementsByClassName('availalibity_2_16_selector_number')[0].innerHTML = number;
        this.setCookie('BookingChildren216',number,1);
    }

    /** Toggle Calendar **/

    toggleCalendar2 = () => {
        this.elements.bookingCalendar.classList.add('visible')
        this.elements.header.classList.add('availability_open')
        document.body.style.overflow = 'hidden'

        this.element.classList.add('availability_visible')
        this.element.classList.remove('availability_hidden')

        this.tl.to(this.element, {
            autoAlpha: 1,
            y: '0',
            ease: 'power4.inOut'
        }).to(this.elements.menuButton, {
            autoAlpha: 0
        },'<').to(this.elements.bookingCalendar, {
            autoAlpha: 1,
            y: 0,
            ease: 'power4.inOut'
        }, '<').to(this.elements.bookingCalendarWrapper, {
            autoAlpha: 1,
            ease: 'power4.inOut'
        }, '+=0.25')
    }

    closeCalendar = () => {
        this.elements.header.classList.remove('availability_open')
        document.body.style.overflow = 'auto'
        this.elements.calendarToggle.addEventListener('click', this.toggleCalendar)
        this.elements.calendarToggle2.addEventListener('click', this.toggleCalendar)
        this.elements.calendarToggle3.addEventListener('click', this.toggleCalendar2)

        this.element.classList.add('availability_hidden')
        this.element.classList.remove('availability_visible')

        this.tl.to(this.elements.bookingCalendar, {
          autoAlpha: 0,
          y: '100%',
          ease: 'power4.inOut'
        }).to(this.elements.menuButton, {
            autoAlpha: 1
        },'<').to(this.elements.bookingCalendarWrapper, {
          autoAlpha: 0,
          ease: 'power4.inOut'
        }, '-=0.25').to(this.element, {
            autoAlpha: 0,
            y: '15.6rem',
            ease: 'power4.inOut'
        }, '<')
    }

    checkIfAllFilledInForm = (e) => {

        var emptyFields = false;

        var input = document.getElementById("mphb_check_in_date");
        if (!(input && input.value)) {
            document.getElementById('inputDatesWarning').classList.add('visible');
            emptyFields = true;
        }


        var input = document.getElementById("mphb_check_out_date");
        if (!(input && input.value)) {
            document.getElementById('inputDatesWarning').classList.add('visible');
            emptyFields = true;
        }

        var input = document.getElementById("mphb_adults");
        if ((!(input && !input.value)) && (input.value == 0)) {
            document.getElementById('inputNrGuestsWarning').classList.add('visible');
            emptyFields = true;
        }


        if(emptyFields){
            e.preventDefault();
        }

    }

    createInteractions = () => {
        this.elements.calendarToggle.addEventListener('click', this.toggleCalendar2)
        this.elements.calendarToggle2.addEventListener('click', this.toggleCalendar2)
        this.elements.calendarToggle3.addEventListener('click', this.toggleCalendar2)
        this.elements.closeBookingCalendar.addEventListener('click', this.closeCalendar)
        this.elements.submitSearchBooking.addEventListener('click', this.checkIfAllFilledInForm)

        /** Adults **/
        this.elements.numberAdultMinus.addEventListener('click', this.numberAdultMinus)
        this.elements.numberAdultPlus.addEventListener('click', this.numberAdultPlus)

        /** 0 to 2 */
        this.elements.number_0_2_minus.addEventListener('click', this.number02Minus)
        this.elements.number_0_2_plus.addEventListener('click', this.number02Plus)

        /** 2 to 16 */
        this.elements.number_2_16_minus.addEventListener('click', this.number216Minus)
        this.elements.number_2_16_plus.addEventListener('click', this.number216Plus)

        /** clear Calendar **/
        this.elements.clearCalendar.addEventListener('click', this.clearCalendar)
    }

    addEventListeners () {
        window.addEventListener('scroll', this.checkScrollDirection.bind(this))
    }
}
